import { render } from "./DemandeList.vue?vue&type=template&id=4148888c&ts=true"
import script from "./DemandeList.vue?vue&type=script&lang=ts"
export * from "./DemandeList.vue?vue&type=script&lang=ts"

import exportComponent from "/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__